<template>
  <TheButton
    v-if="isLogin"
    type="unfilled"
    size="medium"
    :to="`${consoleDomain}/${locale}`"
    title="WISE-Console"
    target="_self"
  >
    <span class="text-sm font-bold">Console</span>
  </TheButton>
</template>

<script setup lang="ts">
  const { locale } = useI18n();
  const { consoleDomain } = useWebsite();

  const profileStore = useProfileStore();
  const { isLogin } = storeToRefs(profileStore);
</script>
